import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Table from "components/Admin/PickupLocations/States/States";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getStates,
  deleteState,
  updateState,
  createState,
  changeStatusState,
} from "store/actions/locationState";

const States = () => {
  const statesData = useSelector((state) => state.locations.states);
  const dispatch = useDispatch();
  const [page, setPage] = useState(statesData ? statesData.pag.page : 1);
  const [amount, setAmount] = useState(statesData ? statesData.pag.amount : 10);
  const [orderField, setOrderField] = useState(
    statesData ? statesData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    statesData ? statesData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    statesData ? statesData.pag.search_by : "name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getStates(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteState(id, pag, history));
  };
  const changeStatusHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(changeStatusState(id, pag, history));
  };
  const createHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(createState(newData, pag, history));
  };
  const updateHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(updateState(newData, pag, history));
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>States Table</h4>
        </CardHeader>
        <CardBody>
          {statesData && (
            <Table
              rows={statesData.data}
              totalRows={statesData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
              createHandler={createHandler}
              updateHandler={updateHandler}
              deleteHandler={deleteHandler}
              changeStatusHandler={changeStatusHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default States;
